/** @jsxImportSource @emotion/react */

import { notification } from "antd";
import { ReactComponent as IconCopy } from "assets/Common/icons/icon-copy.svg";
import Background from "assets/temporary/images/banner_deposit.png";
import { ModalCustom } from "components/Common/ModalCustom";
import { useAppDispatch, useAppSelector } from "hooks/app-hook";
import { useRef } from "react";
import { useTranslation } from "react-i18next";
import { selectOpenModal, setOpenModal } from "store/modal";
import { selectProfile } from "store/user";
import { StatusNotification } from "types";

import { UplineContactModalStyle } from "./style";

const UplineContactModal = () => {
  const dispatch = useAppDispatch();
  const { t, i18n } = useTranslation();
  const dataProfile = useAppSelector(selectProfile);

  const openModal = useAppSelector(selectOpenModal);
  const [api, contextHolder] = notification.useNotification();
  const openNotification = (status: StatusNotification, message: string) => {
    api[status]({
      message,
      description: "",
    });
  };

  const uplineRef = useRef<HTMLDivElement>(null);

  const handleCopy = () => {
    if (uplineRef.current) {
      const text = uplineRef.current.textContent || "";
      navigator.clipboard
        .writeText(text)
        .then(() => {
          openNotification("success", "Copied!" + "");
        })
        .catch((err) => {
          console.error("Failed to copy: ", err);
        });
    }
  };

  return (
    <ModalCustom
      isOpenModal={openModal.includes("uplineContact")}
      handleCloseModal={() => dispatch(setOpenModal(""))}
      titleModal={t("header:UplineContact")}
      headerBackground={Background}
      heightBackground={75}
      bodyModal={
        <div css={UplineContactModalStyle.wrapper}>
          <div className="wrap-inner">
            <div className="upline-number" ref={uplineRef}>
              {dataProfile?.upline_mobile || ""}
            </div>
            <button className="btn-copy" onClick={handleCopy}>
              <IconCopy />
            </button>
          </div>
          {contextHolder}
        </div>
      }
    />
  );
};
export default UplineContactModal;
